import { render, staticRenderFns } from "./mainNew.vue?vue&type=template&id=b87aa330&scoped=true&"
import script from "./mainNew.vue?vue&type=script&lang=js&"
export * from "./mainNew.vue?vue&type=script&lang=js&"
import style0 from "./mainNew.vue?vue&type=style&index=0&id=b87aa330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87aa330",
  null
  
)

export default component.exports